import { notification } from 'antd';

// TODO (SW-2306): Move to a new file for app-level messaging
export const showNotification = (type, message = '', opts = {}) => {
  notification[type]({
    message,
    ...opts,
  });
};

// SW-2306: This file is going away in favor of domain/concept-specific
// helper files. Please don't add new functions to this file.
